import { AutogenModelLocationAddOrders, AutogenRowLocationAddOrders } from "./autogen/AutogenModelLocationAddOrders";

export class ModelLocationAddOrders extends AutogenModelLocationAddOrders<RowLocationAddOrders> {
    constructor() {
        super(RowLocationAddOrders);
    }
}

export class RowLocationAddOrders extends AutogenRowLocationAddOrders {
}